import { Badge, Group } from "@mantine/core";

export function PlaceholderChips({
  placeholders,
  onInsert,
}: {
  placeholders: string[];
  onInsert: (placeholder: string) => void;
}) {
  return (
    <Group spacing={4}>
      {placeholders.map((p) => (
        <Badge
          key={p}
          size="xs"
          variant="outline"
          sx={(theme) => ({
            cursor: "pointer",
            textTransform: "none",
            fontWeight: 500,
            fontSize: 9,
            padding: "0 5px",
            height: 18,
            "&:hover": {
              backgroundColor:
                theme.colorScheme === "dark"
                  ? theme.colors.dark[5]
                  : theme.colors.gray[1],
            },
          })}
          onClick={() => onInsert(p)}
        >
          {p}
        </Badge>
      ))}
    </Group>
  );
}
